
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @nx/enforce-module-boundaries */

import React, { useEffect } from 'react';
import {
  Box,
  Card,
  CardBody,
  Container,
} from '@mybridge/ui';
import { useDispatch, useSelector } from 'react-redux';
import { getStaticPageContent } from 'v4/store/actions/global.data.actions';
const AboutUs = () => {
  const dispatch = useDispatch();
  const { pageContetStatic } = useSelector((state) => state.globalData);
  useEffect(() => {
    dispatch(getStaticPageContent('about-us'));
  }, []);
  return (
    <>
      <Box
        as="hr"
        width="calc(100% + 32px)" 
        marginX="-16px" 
        background="#F9F9F9"
      />
      <Container maxW="1366px" className="static-page-container" p={0}>
        <Card className="static-page-body" boxShadow="none" mt={0}>
          <CardBody mt={0}>
            <Box
            mt={0}
              className="static-page-body"
              dangerouslySetInnerHTML={{
                __html: pageContetStatic?.content,
              }}
            ></Box>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default AboutUs;
